import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../../internal/Page'
import SettingsPanel from '../../../internal/SettingsPanel'
import { getText } from '../../../internal/TextLabels'
import StoreInfoSettingsForm from './StoreInfoSettingsForm'
import { useToggle } from '../../../util/utility-hooks'
import { isValid } from './StoreInfoSettingsHelper'

const StoreInfoSettings = ({ invoiceData, tradeName, country, ...props }) => {
  const [edit, toggleEdit] = useToggle(false)
  const [canSave, setCanSave] = useState(true)

  const generateSettingsModel = () => {
    return {
      legalname:
        invoiceData && invoiceData.address ? invoiceData.address.name : '',
      digitalname: tradeName,
      street:
        invoiceData && invoiceData.address ? invoiceData.address.street : '',
      zip:
        invoiceData && invoiceData.address ? invoiceData.address.zipCode : '',
      city: invoiceData && invoiceData.address ? invoiceData.address.city : '',
      country:
        invoiceData && invoiceData.address
          ? invoiceData.address.country
          : country,
      phone: invoiceData && invoiceData.phone,
      fax: invoiceData && invoiceData.fax,
      email: invoiceData && invoiceData.email,
      web: invoiceData && invoiceData.webpage,
      vatreg: invoiceData && invoiceData.vatreg,
      orgnr: invoiceData && invoiceData.orgnr,
      taxNote: !!(invoiceData && invoiceData.companyTaxNote),
    }
  }

  const [settings, setSettings] = useState(generateSettingsModel())
  const [originalSettings, setOriginalSettings] = useState(
    generateSettingsModel(),
  )

  const generateRequestObject = () => {
    const {
      city,
      country: c,
      legalname,
      street,
      zip,
      taxNote,
      email,
      fax,
      orgnr,
      phone,
      web,
      vatreg,
    } = settings

    return {
      address: {
        city,
        country: c,
        name: legalname,
        street,
        zipCode: zip,
      },
      companyTaxNote: taxNote,
      email,
      fax,
      orgnr,
      phone,
      webpage: web,
      vatreg,
    }
  }

  const updateData = (field, value) => {
    const newSettings = { ...settings, [field]: value }
    setSettings(newSettings)
    setCanSave(isValid(newSettings))
  }

  const saveData = () => {
    const newTradeName =
      tradeName !== settings.digitalname ? settings.digitalname : undefined
    props.updateStoreSettings(generateRequestObject(), newTradeName)
    setOriginalSettings(settings)
  }

  const resetData = () => {
    setSettings({ ...originalSettings })
  }

  const onCancelEdit = () => {
    resetData()
    toggleEdit()
    setCanSave(true)
  }

  const onSave = () => {
    saveData()
    toggleEdit()
  }

  const buttons = edit
    ? [
        {
          text: getText('default.cancel'),
          action: onCancelEdit,
        },
        {
          text: getText('default.save'),
          type: 'primary',
          disabled: !canSave,
          action: onSave,
        },
      ]
    : [
        {
          text: getText('default.edit'),
          action: toggleEdit,
        },
      ]
  return (
    <Page>
      <SettingsPanel
        header={getText('storeSettings.storeinfo.header')}
        buttons={buttons}
      >
        <StoreInfoSettingsForm
          settings={settings}
          onChange={(f, v) => updateData(f, v)}
          editMode={edit}
          country={country}
        />
      </SettingsPanel>
    </Page>
  )
}

StoreInfoSettings.propTypes = {
  invoiceData: PropTypes.object.isRequired,
  tradeName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  updateStoreSettings: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  currentRepresentative: state.storeInfo.currentRepresentative,
  currentStore: state.storeInfo.currentStore,
})

export default connect(mapStateToProps)(StoreInfoSettings)
